/* settings not found div */
const SettingsDataNotFoundComp = {
  components: {
    SpinnerComp,
  },
  emits: ["resetFilters"],
  delimiters: ["[[", "]]"],
  template: `#settings-data-not-found`,
  props: ["isLoading"],
};

/*grid view component */
const SettingsGridViewComp = {
  components: {
    SpinnerComp,
    DiamondDetailPopupComp,
  },

  setup(props, context) {
    const diamondCompareState = inject("diamondsForCompare");
    const currentGridTab = inject("currentGridTab");
    const diamondDataState = reactive({
      diamondId: "",
    });
    provide("diamondDataState", diamondDataState);
    function showDetailPopup(e, diamondId) {
      diamondDataState.diamondId = diamondId;
    }
    function sendDiamondsForCompare(e, diamondObj) {
      context.emit("pCompareDiamonds", e.target.checked, diamondObj);
      context.emit("pHandleTooltip", e.target.checked);
    }

    return {
      showDetailPopup,
      sendDiamondsForCompare,
      ...toRefs(currentGridTab),
      ...toRefs(diamondCompareState),
      ...toRefs(diamondDataState),
    };
  },
  props: [
    "items",
    "topSellingItems",
    "diamondCount",
    "currentPage",
    "pageLimit",
    "isLoading",
    "wishlistItems",
  ],
  emits: [
    "loadMoreItems",
    "pCompareDiamonds",
    "pHandleTooltip",
    "addToWishlistParent",
    "imageError",
  ],
  data() {
    return {
      mainImgUrl: "",
      newlayout: true,
      loadingGIF: `${baseAssetsUrl}/loading.gif`,
      bannerTwoIndex: [],
      bannerThreeIndex: [],
      bannerFourIndex: [],
      productDivClass: "",
      bannerNameArray: [],
    };
  },
  delimiters: ["[[", "]]"],
  template: `#settings-grid-view-result`,
  computed: {
    getFormattedPrice() {
      // first type : $4512.63
      // return (item) => {
      //   return `$${item?.price?.toLocaleString("en-US", {
      //     minimumFractionDigits: 2,
      //   })}`;
      // };

      // second type : A$1452.23
      // return (item) => {
      //   // Ensure price is a number and currency is defined
      //   const price = Number(item?.price || 0);
      //   const currency = item?.currency || 'IND'; // Default to USD if undefined

      //   return price.toLocaleString("en-US", {
      //     style: "currency",
      //     currency: currency,
      //     minimumFractionDigits: 2,
      //   });
      // };

      // third type : AUD14523.21
      return (item) => {
        const price = Number(item?.price || 0).toFixed(0);
        const newPrice = `${item?.currency}${price?.toLocaleString("en-US", {
          minimumFractionDigits: 2,
        })}`;
        return newPrice;
      };
    },
  },
  watch: {
      diamondCount() {
        const width = window.innerWidth;

        /* ≥ 1200px → Banner 4 */
        if (width >= 1200) {
          this.bannerFourCountAssign(
            [10],
            10,
            this.$props.diamondCount,
            [11]
          );
        }

        /* 768px – 1199px → Banner 3 */
        else if (width >= 768) {
          this.bannerThreeCountAssign(
            [4],
            4,
            this.$props.diamondCount,
            [5]
          );
        }

        /* ≤ 767px (EXACT 767 INCLUDED) → Banner 2 */
        else {
          this.bannerTwoCountAssign(
            [9],
            9,
            this.$props.diamondCount,
            [10]
          );
        }
      },
  },
  mounted() {
    if (window.innerWidth < 993) {
      this.productDivClass = "pc-div-full";
    }
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    // Grab hidden input value
    const el = document.getElementById("setting-banners");
    if (el && el.value) {
      this.bannerNameArray = JSON.parse(el.value);
    }
  },
  methods: {
    isIncludedInTopSelling(id) {
      return this.$props.topSellingItems?.length
        ? this.topSellingItems.some((item) => item.id == id) // check if any item's id matches
        : false;
    },
    nextSlide() {
      const track = this.$refs.sliderTrack;
      track.scrollBy({ left: 350, behavior: "smooth" });
    },
    prevSlide() {
      const track = this.$refs.sliderTrack;
      track.scrollBy({ left: -350, behavior: "smooth" });
    },
    getbannerPath(index, column) {
      if (column == "three") {
        let bannerIndex = this.bannerThreeIndex.indexOf(index);
        if (bannerIndex != -1) {
          let i = bannerIndex % this.bannerNameArray.length;
          return this.bannerNameArray[i];
        }
      } else if (column == "two") {
        let bannerIndex = this.bannerTwoIndex.indexOf(index);
        if (bannerIndex != -1) {
          let i = bannerIndex % this.bannerNameArray.length;
          return this.bannerNameArray[i];
        }
      } else {
        let bannerIndex = this.bannerFourIndex.indexOf(index);
        if (bannerIndex != -1) {
          let i = bannerIndex % this.bannerNameArray.length;
          return this.bannerNameArray[i];
        }
      }
    },
    bannerTwoCountAssign(result, start, end, interval) {
      const results = result;
      let current = start;

      while (current + interval[interval.length - 1] < end) {
        for (const step of interval) {
          current += step;
          results.push(current);
        }
      }
      this.bannerTwoIndex = results;
    },
    bannerThreeCountAssign(results, start, end, interval) {
      const result = results;
      let current = start;

      while (current + interval[interval.length - 1] < end) {
        for (const step of interval) {
          current += step;
          result.push(current);
        }
      }

      this.bannerThreeIndex = result;
    },
    bannerFourCountAssign(result, start, end, interval) {
      const results = result;
      let current = start;

      while (current + interval[interval.length - 1] < end) {
        for (const step of interval) {
          current += step;
          results.push(current);
        }
      }
      this.bannerFourIndex = results;
    },
    handleResize() {
      const width = window.innerWidth;

      /* ≥1200px — Banner Four */
      if (width >= 1200) {
        this.bannerTwoIndex = [];
        this.bannerThreeIndex = [];

        this.bannerFourIndex = [];
        this.bannerFourCountAssign([10], 10, this.$props.diamondCount, [11]);

        this.productDivClass = "";
      }

      /* 768px–1199px — Banner Three */
      else if (width >= 768) {
        this.bannerTwoIndex = [];
        this.bannerFourIndex = [];

        this.bannerThreeIndex = [];
        this.bannerThreeCountAssign([4], 4, this.$props.diamondCount, [5]);

        this.productDivClass = "pc-div-full";
      }

      /* <768px — TRUE Mobile */
      else {
        this.bannerThreeIndex = [];
        this.bannerFourIndex = [];

        this.bannerTwoIndex = [];
        this.bannerTwoCountAssign([9], 9, this.$props.diamondCount, [10]);

        this.productDivClass = "";
      }
    },
    showPage(e, settingsHandle, settingsId) {
      e.preventDefault();
      e.stopPropagation();
      this.$route.params.setting &&
        localStorage.setItem(
          "settingname",
          this.$route.params.setting.toLowerCase()
        );
      window.location.href = `/collections/engagement-rings/products/${settingsHandle}?variant=${settingsId}`;
      // this.$router.push({ path: `/products/${settingsId}` });
      // this.$router.push({ path: `/engagement-rings/settings/${settingsId}` });
    },
    toggleAlternateImg(e, action) {
      if (
        (!e.target.getAttribute("src").includes("svg") &&
          e.target.getAttribute("alt-img") != e.target.getAttribute("src")) ||
        !!sessionStorage.getItem("test-alternate-image")
      ) {
        if (action == "show") {
          var alternateImg =
            sessionStorage.getItem("test-alternate-image") ||
            e.target.getAttribute("alt-img"); /*  for dev */
          var mainImg = e.target.getAttribute("src");
          // e.target.style.opacity = '0'
          this.mainImgUrl = mainImg;
          e.target.setAttribute("src", alternateImg);
          e.target.setAttribute("alt-img", mainImg);
        } else {
          // e.target.style.opacity = '0'
          var alternativeImage =
            sessionStorage.getItem("test-alternate-image") ||
            e.target.getAttribute("src");
          // e.target.style.opacity = '1'

          e.target.setAttribute("src", this.mainImgUrl);
          e.target.setAttribute("alt-img", alternativeImage);
          this.mainImgUrl = "";
        }
      }
    },
  },
};

/* filter page component */
const ChooseSettingComp = {
  sliderOptions: ["price"],
  regularFilters: ["shapes", "settingStyles", "metals", "price"],
  settingStyles: [
    "Classic",
    "Contemporary",
    "Halo",
    "Solitaire",
    "Three Stone",
  ],
  resultLimit: 12,
  filtersTooltip: {
    shape: {
      title: "Diamond Shape",
      content:
        "Diamond prices fluctuate frequently based on supply and demand or during our limited-time sales. For specific pricing information on your diamond of interest please click on that diamond in the search results below.",
    },
    price: {
      title: "Diamond Price",
      content:
        "Diamond prices fluctuate frequently based on supply and demand or during our limited-time sales. For specific pricing information on your diamond of interest please click on that diamond in the search results below.",
    },
    carat: {
      title: "Diamond Carat",
      content:
        "Diamond prices fluctuate frequently based on supply and demand or during our limited-time sales. For specific pricing information on your diamond of interest please click on that diamond in the search results below.",
    },
    cut: {
      title: "Diamond Cut",
      content:
        "Diamond prices fluctuate frequently based on supply and demand or during our limited-time sales. For specific pricing information on your diamond of interest please click on that diamond in the search results below.",
    },
    clarity: {
      title: "Diamond Clarity",
      content:
        "Diamond prices fluctuate frequently based on supply and demand or during our limited-time sales. For specific pricing information on your diamond of interest please click on that diamond in the search results below.",
    },
    color: {
      title: "Diamond Colour",
      content:
        "Diamond prices fluctuate frequently based on supply and demand or during our limited-time sales. For specific pricing information on your diamond of interest please click on that diamond in the search results below.",
    },
    lab: {
      title: "Lab",
      content:
        "Diamond prices fluctuate frequently based on supply and demand or during our limited-time sales. For specific pricing information on your diamond of interest please click on that diamond in the search results below.",
    },
    polish: {
      title: "Diamond Polish",
      content:
        "Diamond prices fluctuate frequently based on supply and demand or during our limited-time sales. For specific pricing information on your diamond of interest please click on that diamond in the search results below.",
    },
    symmetry: {
      title: "Diamond Symmetry",
      content:
        "Diamond prices fluctuate frequently based on supply and demand or during our limited-time sales. For specific pricing information on your diamond of interest please click on that diamond in the search results below.",
    },
    fluroscence: {
      title: "Diamond Fluroscence",
      content:
        "Diamond prices fluctuate frequently based on supply and demand or during our limited-time sales. For specific pricing information on your diamond of interest please click on that diamond in the search results below.",
    },
    depth: {
      title: "Diamond Depth",
      content:
        "Diamond prices fluctuate frequently based on supply and demand or during our limited-time sales. For specific pricing information on your diamond of interest please click on that diamond in the search results below.",
    },
    table: {
      title: "Diamond Table",
      content:
        "Diamond prices fluctuate frequently based on supply and demand or during our limited-time sales. For specific pricing information on your diamond of interest please click on that diamond in the search results below.",
    },
  },
  components: {
    slider: VueformSlider,
    SettingsGridViewComp,
    SettingsDataNotFoundComp,
    SpinnerComp,
    ResetFormComp,
    BreadcrumbsComp,
    WishlistPopupComp,
    HeaderStepsComp,
    StickyBarComp,
    PageBannerComp,
  },
  setup(props, context) {
    const diamondCompareState = reactive({
      diamondsForCompare: [],
      diamonds: [],
    });
    const filterInfoTooltipState = reactive({
      filterId: "",
    });
    const gridTabState = reactive({
      currentTab: "diamond",
    });

    provide("diamondsForCompare", diamondCompareState);
    provide("currentGridTab", gridTabState);

    function compareDiamonds(isChecked, diamondObj) {
      handleComparedDiamonds("set", diamondCompareState.diamondsForCompare);
      handleDiamondData(isChecked, diamondObj);
    }
    function handleDiamondData(isChecked, diamondObj) {
      if (isChecked) {
        diamondCompareState.diamonds.push(diamondObj);
      } else {
        diamondCompareState.diamonds = diamondCompareState.diamonds.filter(
          function (diamondJson) {
            if (diamondJson.diamondId != diamondObj.diamondId) {
              return diamondJson;
            }
          }
        );
      }
      if (diamondCompareState.diamonds.length < 1) {
        sessionStorage.removeItem("compareDiamonds");
      } else {
        sessionStorage.setItem(
          "compareDiamonds",
          JSON.stringify(diamondCompareState.diamonds)
        );
      }
    }
    function handleComparedDiamonds(action, diamonds = []) {
      if (action === "set") {
        if (diamonds.length < 1) {
          sessionStorage.removeItem("comparedDiamondList");
        } else {
          sessionStorage.setItem("comparedDiamondList", diamonds);
        }
      } else {
        if (sessionStorage.getItem("comparedDiamondList") != null) {
          return sessionStorage.getItem("comparedDiamondList").split(",");
        } else {
          return null;
        }
      }
    }
    function openFilterInfoTooltip(e, filterId) {
      filterInfoTooltipState.filterId = filterId;
    }
    function changeGridTab(tab) {
      gridTabState.currentTab = tab;
    }
    onMounted(() => {
      const route = useRoute();
      if (
        handleComparedDiamonds("get") != null &&
        sessionStorage.getItem("compareDiamonds") != null
      ) {
        diamondCompareState.diamondsForCompare = handleComparedDiamonds("get");
        diamondCompareState.diamonds = JSON.parse(
          sessionStorage.getItem("compareDiamonds")
        );
      }
    });
    return {
      openFilterInfoTooltip,
      compareDiamonds,
      changeGridTab,
      ...toRefs(diamondCompareState),
      ...toRefs(gridTabState),
      ...toRefs(filterInfoTooltipState),
    };
  },
  data() {
    return {
      tabTitle: "Choose Settings",
      gridTabLabel: "Setting Styles",
      request: null,
      diamondCount: 0,
      loading: false,
      sendRequest: true,
      dataNotFound: false,
      page: 1,
      isMoreData: false,
      items: [],
      topSellingItems: [],
      slideDown: false,
      toggleClass: "",
      bannerClass: "pc-show-banner",
      showResetFilters: false,
      showCertError: false,
      openFilterSection: false,
      showTooltip: false,
      hideElementOnMobile: false,
      tooltipText: "",
      tooltipClass: "",
      breadcrumbs: [],
      timeOutId: "",
      showCompare: false,
      hideCompareDiamondsTab: true,
      hideResultViewSwitch: true,
      currentFilterTab: "View All",
      showWishlistPopup: false,
      WishlistPopupContent: "",
      wishlistItemName: "",
      pageInfo: {
        endCursor: null,
        hasNextPage: false,
        hasPreviousPage: false,
        startCursor: null,
      },
      filters: {
        initialFilters: {
          isTopSelling: null,
          showAppliedFiltersSection: false,
          certificateNumber: "",
          isListView: true,
          shapes: [],
          settingStyles: [],
          metals: "9k-white-gold",
          // metals: ["14k-white-gold"],
          wishlistItems: [],
          sortby: "price_asc",
          price: {
            value: [parseInt(settingMinPrice), parseInt(settingMaxPrice)],
          },
          sortColumnsWidth: "14.28%",
        },
        price: {
          symbol: currencySymbol,
          min: parseInt(settingMinPrice),
          max: parseInt(settingMaxPrice),
          step: 1,
        },
        shapes: [],
        settingStyles: [],
        metals: [],
      },
      selectedDiamondShapes: [],
      stepData: (function() {
        var fp = sessionStorage.getItem("firstPage");
        if (fp == "diamondPage") {
          return { firstStep: { headerTitle: "DIAMOND" }, secondStep: { headerTitle: "SETTING" }, thirdStep: { headerTitle: "Ring" } };
        }
        return { firstStep: { headerTitle: "SETTING" }, secondStep: { headerTitle: "DIAMOND" }, thirdStep: { headerTitle: "Ring" } };
      })(),
      totalSteps: 1,
      pageStickyItems: [],
      showBannerTitle: true,
      bannerTitle: "Select Your Setting",
      recentSetting: "",
      isComponentMounted: false,
      newlayout: false,
      isTooltipVisible: "",
      addFilterResultSectionClass: false,
      isDDOpen: false,
      redirectPage: "",
      isLoadMoreBtnActive: false,
      showLeftArrowMetal: false,
      showRightArrowMetal: true,
      showLeftArrowStyle: false,
      showRightArrowStyle: true,
      showLeftArrowShape: false,
      showRightArrowShape: true,
    };
  },
  delimiters: ["[[", "]]"],
  template: "#settings-filter-page",
  computed: {
    getShapes() {
      return this.filters.shapes;
    },
    getMetals() {
      return this.filters.metals;
    },
    getSettingStyles() {
      return this.filters.settingStyles;
    },
    /* Which style-specific FAQ block dynamic-custom-faqs-engagement-rings renders.
       settingStyles already merges the path style (/collections/engagement-rings/vintage)
       with the ?setting_styles=a+b query, so this covers both entry points and updates
       live as filters are ticked. Exactly one style selected -> that style's FAQ; none or
       several -> "" so the general engagement ring FAQ shows instead. */
    activeFaqStyle() {
      const styles = this.filters?.initialFilters?.settingStyles || [];
      return styles.length === 1 ? String(styles[0]).toLowerCase() : "";
    },
    getMetalFormattedLabel() {
      return (metalLabel) => {
        var labelTokens = metalLabel.split(" ");
        var newLabel =
          labelTokens.length > 1
            ? `${labelTokens.slice(1).join(" ")}`
            : labelTokens.join(" ");
        return newLabel;
      };
    },
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  mounted() {
    this.checkArrowsMetal();
    this.checkArrowsStyle();
    this.checkArrowsShape();
    this.setPageMetaData();
    if (!!sessionStorage.getItem("settingListPageInfo")) {
      this.pageInfo = JSON.parse(sessionStorage.getItem("settingListPageInfo"));
    }
    if (!!sessionStorage.getItem("redirection")) {
      this.redirectPage = sessionStorage
        .getItem("redirection")
        .includes("-diamonds")
        ? "DIAMOND"
        : "SETTING";
    }
    if (localStorage.getItem("settingname")) {
      localStorage.removeItem("settingname");
    }
    this.isComponentMounted = true;
    this.handleMetaData();
    this.handleBreadcrumbs();
    this.loadSettingFilters();
    this.injectAppliedFilters();
    this.filters.initialFilters.isListView = false;
    if (window.innerWidth <= 676) {
      this.hideElementOnMobile = true;
    }
    this.handleUrlFilters();
    this.handleSelectedDiamondShapes();
    this.handleBannerTitle();
    this.initDiamondGridScroll();
    this.handleStepData();
    this.handleStickyBarItems();
    this.loadCachedData();
    this.shouldShowAppliedFilters();
    handlePageBodyClass("add", "pc-ringbuilder-setting-listing-page");
    document.addEventListener("click", (element) => {
      this.isTooltipVisible = "";
      this.isDDOpen = false;
    });
  },
  beforeUnmount() {
    this.isComponentMounted = false;
    document.removeEventListener("click", () => (this.isTooltipVisible = ""));
    handlePageBodyClass("remove", "pc-ringbuilder-setting-listing-page");
  },
  methods: {
    scrollLeftStyle() {
      this.$refs.styleScroll.scrollBy({ left: -200, behavior: "smooth" });
      this.$nextTick(this.checkArrowsStyle);
    },
    scrollRightStyle() {
      this.$refs.styleScroll.scrollBy({ left: 200, behavior: "smooth" });
      this.$nextTick(this.checkArrowsStyle);
    },
    checkArrowsStyle() {
      const el = this.$refs.styleScroll;
      if (!el) return;
      this.showLeftArrowStyle = el.scrollLeft > 0;
      this.showRightArrowStyle =
        el.scrollLeft + el.clientWidth < el.scrollWidth;
    },
    scrollLeftMetal() {
      this.$refs.metalScroll.scrollBy({ left: -200, behavior: "smooth" });
      this.$nextTick(this.checkArrowsMetal);
    },
    scrollRightMetal() {
      this.$refs.metalScroll.scrollBy({ left: 200, behavior: "smooth" });
      this.$nextTick(this.checkArrowsMetal);
    },
    checkArrowsMetal() {
      const el = this.$refs.metalScroll;
      if (!el) return;
      this.showLeftArrowMetal = el.scrollLeft > 0;
      this.showRightArrowMetal =
        el.scrollLeft + el.clientWidth < el.scrollWidth;
    },

    scrollLeftShape() {
      this.$refs.shapeScroll.scrollBy({ left: -200, behavior: "smooth" });
      this.$nextTick(this.checkArrowsShape);
    },
    scrollRightShape() {
      this.$refs.shapeScroll.scrollBy({ left: 200, behavior: "smooth" });
      this.$nextTick(this.checkArrowsShape);
    },
    checkArrowsShape() {
      const el = this.$refs.shapeScroll;
      if (!el) return;
      this.showLeftArrowShape = el.scrollLeft > 0;
      this.showRightArrowShape =
        el.scrollLeft + el.clientWidth < el.scrollWidth;
    },

    setPageMetaData() {
      // Get the current URL and extract the slug
      const currentUrl = window.location.href;
      const urlParts = currentUrl.split("/");
      const slug = urlParts.pop().toLocaleLowerCase().replaceAll("-", "_"); // e.g., 'pave' from '/collections/engagement-rings/pave'

      // Check if the collection name is "Engagement Rings" (approximated from URL)
      const collectionPath = urlParts[urlParts.length - 1]; // e.g., 'engagement-rings'
      const isEngagementRings = collectionPath === "engagement-rings";

      if (isEngagementRings) {
        // Access Shopify section settings (rendered via Liquid or ShopifyConfig)
        const sectionSettings = window.ShopifyConfig.settingStylesMeta || {};

        // Construct the meta key based on the slug (e.g., 'pave_meta_title')
        const metaTitleKey = `${slug}_meta_title`;
        const metaDescriptionKey = `${slug}_meta_description`;

        // Get meta data from settings
        const metaTitle = sectionSettings[metaTitleKey];
        const metaDescription = sectionSettings[metaDescriptionKey];

        // Only update if meta data is found (not undefined or empty)
        if (metaTitle && metaDescription) {
          // Update page title and meta tags
          this.pageTitle = metaTitle;
          this.pageDescription = metaDescription;
          document.title = metaTitle;

          // Update or create meta tags
          let metaTitleTag = document.querySelector('head meta[name="title"]');
          if (!metaTitleTag) {
            metaTitleTag = document.createElement("meta");
            metaTitleTag.setAttribute("name", "title");
            document.head.appendChild(metaTitleTag);
          }
          metaTitleTag.setAttribute("content", metaTitle);

          let metaDescriptionTag = document.querySelector(
            'head meta[name="description"]'
          );
          if (!metaDescriptionTag) {
            metaDescriptionTag = document.createElement("meta");
            metaDescriptionTag.setAttribute("name", "description");
            document.head.appendChild(metaDescriptionTag);
          }
          metaDescriptionTag.setAttribute("content", metaDescription);
        }
      }
    },
    openFilterSectionTab() {
      let klaviyoSendMessageDiv = document.querySelector(
        ".needsclick.kl-teaser-SeKnfZ.kl-private-reset-css-Xuajs1"
      );
      if (!!klaviyoSendMessageDiv) {
        klaviyoSendMessageDiv.style.zIndex = "0";
      }
      this.openFilterSection = true;
      this.addFilterResultSectionClass = true;
      if (this.currentFilterTab != "View All") {
        this.currentFilterTab = "View All";
      }
    },
    hideFilterSection() {
      let klaviyoSendMessageDiv = document.querySelector(
        ".needsclick.kl-teaser-SeKnfZ.kl-private-reset-css-Xuajs1"
      );
      if (!!klaviyoSendMessageDiv) {
        klaviyoSendMessageDiv.style.zIndex = "90000";
      }
    },
    openDropDown(event) {
      event.stopPropagation();
      this.isDDOpen = true;
    },
    openPopup(e, num) {
      e.stopPropagation();
      this.isTooltipVisible = this.isTooltipVisible === num ? "" : num;
    },
    initDiamondGridScroll() {
      if (document.getElementById("infinite-list")) {
        document
          .getElementById("infinite-list")
          .scrollTo({ top: 0, behavior: "smooth" });
      }
    },
    loadCachedData() {
      // /* set current page and scrolled diamond list from cached session storage */
      // if (
      //   this.getCurrentPageFromSession() != null &&
      //   this.getSettingsFromSession().length &&
      //   this.getSettingCountFromSession() != null &&
      //   sessionStorage.getItem("settingDetailPageViewedId") != null
      // ) {
      //   this.loading = false;
      //   this.dataNotFound = false;
      //   this.page = parseInt(this.getCurrentPageFromSession());
      //   this.items = this.getSettingsFromSession();
      //   this.diamondCount = parseInt(this.getSettingCountFromSession());
      //   this.loadRecentSetting();
      //   this.scrollToRecentSetting();
      // } else {
      /* remove settinglist and current page, setting count from cached session before load new settings from ajax */
      this.removeSettingMetaData();
      this.loadSettings();
      // }
    },
    loadRecentSetting() {
      if (sessionStorage.getItem("settingDetailPageViewedId")) {
        var recentSetting = sessionStorage.getItem("settingDetailPageViewedId");
        if (recentSetting != null) {
          this.recentSetting = parseInt(recentSetting);
        }
      }
    },
    scrollToRecentSetting() {
      setTimeout(() => {
        var elementUptoScroll = document.querySelector(
          `.setting-detail-${this.recentSetting}`
        );
        if (elementUptoScroll != undefined || elementUptoScroll != null) {
          elementUptoScroll.classList.add("pc-highlight_item");
          elementUptoScroll.scrollIntoView({
            block: "center",
            behavior: "smooth",
          });
          sessionStorage.removeItem("settingDetailPageViewedId");
        }
      }, 1000);
    },
    removeSettingMetaData() {
      this.removeCurrentPageFromSession();
      this.removeSettingsFromSession();
      this.removeSettingCountFromSession();
    },
    getSettingSessionVariable() {
      return `settingList`;
    },
    getPageSessionVariable() {
      return `settingCurrentPage`;
    },
    getSettingCountVariable() {
      return `settingCount`;
    },
    saveSettingsToSession(settings) {
      // var settingList = []
      // if (sessionStorage.getItem(this.getSettingSessionVariable())) {
      //     settingList = JSON.parse(sessionStorage.getItem(this.getSettingSessionVariable()))
      //     settingList.push(...settings)
      // } else {
      //     settingList.push(...settings)
      // }
      sessionStorage.setItem(
        this.getSettingSessionVariable(),
        JSON.stringify(settings)
      );
    },
    saveCurrentPageToSession(curPage) {
      sessionStorage.setItem(this.getPageSessionVariable(), curPage);
    },
    saveSettingCountToSession(settingCount) {
      sessionStorage.setItem(this.getSettingCountVariable(), settingCount);
    },
    getCurrentPageFromSession() {
      return sessionStorage.getItem(this.getPageSessionVariable());
    },
    getSettingsFromSession() {
      var settingList = [];
      if (sessionStorage.getItem(this.getSettingSessionVariable())) {
        settingList = JSON.parse(
          sessionStorage.getItem(this.getSettingSessionVariable())
        );
      }
      return settingList;
    },
    getSettingCountFromSession() {
      return sessionStorage.getItem(this.getSettingCountVariable());
    },
    removeCurrentPageFromSession() {
      if (sessionStorage.getItem(this.getPageSessionVariable())) {
        sessionStorage.removeItem(this.getPageSessionVariable());
      }
    },
    removeSettingsFromSession() {
      if (sessionStorage.getItem(this.getSettingSessionVariable())) {
        sessionStorage.removeItem(this.getSettingSessionVariable());
      }
    },
    removeSettingCountFromSession() {
      if (sessionStorage.getItem(this.getSettingCountVariable())) {
        sessionStorage.removeItem(this.getSettingCountVariable());
      }
    },
    handleBannerTitle() {
      var firstPage = sessionStorage.getItem("firstPage");
      if (firstPage == "settingPage") {
        this.showBannerTitle = true;
      }
    },
    // The shape of the diamond already in the build as a setting shape slug
    // ("EMERALD" -> "emerald"), or "" when no diamond is chosen.
    getSelectedDiamondShapeSlug() {
      const selectedDiamond = safeParseJSON("selectedDiamond");
      return `${selectedDiamond?.shape || ""}`.trim().toLowerCase();
    },
    // The chosen diamond decides the shape. It is taken from the diamond itself,
    // not from the diamond list's shape filter: that filter is empty when the
    // diamond was opened from an unfiltered list, which used to leave
    // ["", "emerald"] here (a ",Emerald" chip, no shape selected, no shape
    // applied to the products). Stored as one slug string, so the shape
    // radio's v-model and loadSettings() both match it.
    handleSelectedDiamondShapes() {
      const diamondShape = this.getSelectedDiamondShapeSlug();
      if (!diamondShape) return;
      this.filters.initialFilters.shapes = diamondShape;
      if (sessionStorage.getItem("firstPage") != "settingPage") {
        this.selectedDiamondShapes = [diamondShape];
        this.currentFilterTab = "View All";
      }
    },
    initializeSteps() {
      /* init steps if user reset from same page */
      var firstPage = sessionStorage.getItem("firstPage");
      if (firstPage == "diamondPage") {
        this.stepData = {
          firstStep: { headerTitle: "DIAMOND" },
          secondStep: { headerTitle: "SETTING" },
          thirdStep: { headerTitle: "Ring" },
        };
      } else {
        this.stepData = {
          firstStep: { headerTitle: "SETTING" },
          secondStep: { headerTitle: "DIAMOND" },
          thirdStep: { headerTitle: "Ring" },
        };
      }
      /* after reset, highlight current step */
      this.totalSteps = (firstPage == "diamondPage") ? 2 : 1;
      /* init sticky items if user reset from same page */
      this.pageStickyItems = [];
      this.resetFilters();
    },
    handleStepData() {
      if (sessionStorage.getItem("stepData")) {
        this.stepData = JSON.parse(sessionStorage.getItem("stepData"));
      }
      if (sessionStorage.getItem("firstPage")) {
        var firstPage = sessionStorage.getItem("firstPage");
        if (firstPage == "settingPage") {
          this.stepData.firstStep.headerTitle = "SETTING";
          this.stepData.secondStep.headerTitle = "DIAMOND";
          /* handle setting price for first step */
          this.stepData.firstStep = this.getConvertedStepPrice(
            this.stepData.firstStep
          );
          /* handle diamond price for second step */
          this.stepData.secondStep = this.getConvertedStepPrice(
            this.stepData.secondStep
          );
        } else if (firstPage == "diamondPage") {
          this.stepData.firstStep.headerTitle = "DIAMOND";
          this.stepData.secondStep.headerTitle = "SETTING";
          /* handle setting price for second step */
          this.stepData.secondStep = this.getConvertedStepPrice(
            this.stepData.secondStep
          );
          /* handle diamond price for first step */
          this.stepData.firstStep = this.getConvertedStepPrice(
            this.stepData.firstStep
          );
        }
        /* handle third step as per currency */
        this.stepData.thirdStep = this.getConvertedStepPrice(
          this.stepData.thirdStep
        );
      }
      /* calculate totalSteps based on which steps actually have selections */
      var count = 0;
      if (this.stepData.firstStep && this.stepData.firstStep.title) count++;
      if (this.stepData.secondStep && this.stepData.secondStep.title) count++;
      if (this.stepData.thirdStep && this.stepData.thirdStep.title) count++;
      /* ensure current step (setting) is at least highlighted */
      var firstPage = sessionStorage.getItem("firstPage");
      var currentStepPos = (firstPage == "diamondPage") ? 2 : 1;
      this.totalSteps = Math.max(count, currentStepPos);
    },
    getConvertedStepPrice(step) {
      if (step.hasOwnProperty("price")) {
        step = getCurrencyWiseStep(step);
      }
      return step;
    },
    handleStickyBarItems() {
      if (sessionStorage.getItem("stickyBarItems")) {
        this.pageStickyItems = this.getConvertedStickyBarItems(
          JSON.parse(sessionStorage.getItem("stickyBarItems"))
        );
      }
    },
    getConvertedStickyBarItems(stickyBarItems) {
      if (stickyBarItems.length) {
        stickyBarItems.map((stickyBarItem) => {
          if (stickyBarItem?.hasOwnProperty("price")) {
            stickyBarItem = getCurrencyWiseStickyItem(stickyBarItem);
          }
        });
      }
      return stickyBarItems;
    },
    addClassToFilterTab(filterTab) {
      this.currentFilterTab = filterTab;
    },
    isInViewport(element) {
      const box = element?.getBoundingClientRect();
      return box?.top - 300 < window.innerHeight && box?.bottom >= 0;
    },
    handleScroll(e) {
      if (
        !this.pageInfo?.hasNextPage ||
        !this.isComponentMounted ||
        !this.sendRequest
      )
        return;

      const footerElement = document.querySelector(".choose-setting-footer");
      if (this?.isInViewport(footerElement)) {
        this.loadSettings(true);
      }
    },

    handleLoadMoreButtonClick() {
      this.isLoadMoreBtnActive = false; // Hide button after first click
      this.loadSettings(true); // Start loading
    },

    async fetchVariantOptions({
      apiVersion,
      accessToken,
      collectionHandle,
      filters,
      cursor = null,
      isNextPage = true,
    }) {
      try {
        const conditions = [];
        if (collectionHandle)
          conditions.push(`product_type:'${collectionHandle}'`);

        if (filters?.tag?.length) {
          const tagOrQuery = filters?.tag.map((t) => `tag:'${t}'`).join(" OR ");
          conditions.push(`(${tagOrQuery})`);
        }
        const queryCondition = conditions.length
          ? `query: "${conditions.join(" AND ")}"`
          : "";

        const query = `{
            products(
              first: ${filters?.itemsPerPage},
              ${cursor ? `${isNextPage ? "after" : "before"}: "${cursor}"` : ""
          },
              sortKey: ${filters?.sortItems.sortBy},
              reverse: ${filters?.sortItems.isDescending},
              ${queryCondition}
            ) {
              pageInfo {
                endCursor
                hasNextPage
                hasPreviousPage
                startCursor
              }
              edges {
                node {
                  id
                  handle
                  title
                  tags
                  priceRange {
                    minVariantPrice { amount currencyCode }
                    maxVariantPrice { amount currencyCode }
                  }
                  images(first: 10) {
                    edges { node { altText id originalSrc transformedSrc url width height } }
                  }
                  variants(first: 100) {
                    edges {
                      node {
                        id
                        title sku
                        priceV2 { amount currencyCode }
                        selectedOptions { name value }
                        image{
                          src
                        }
                      }
                    }
                  }
                }
              }
            }
          }`;

        const response = await fetch(`/api/${apiVersion}/graphql.json`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // "X-Shopify-Storefront-Access-Token": accessToken,
          },
          body: JSON.stringify({ query }),
        });

        if (!response.ok) {
          console.error(
            `HTTP Error: ${response.status}`,
            await response.text()
          );
          return null;
        }

        const data = await response.json();
        const filteredData = this.getFilteredProducts(data, filters);

        return {
          products: filteredData?.length ? filteredData : null,
          pageInfo: data?.data?.products?.pageInfo,
        };
      } catch (error) {
        console.error("Error fetching variant options:", error);
        throw error;
      }
    },

    // getFilteredProducts(data, filters) {
    //   const products = data?.data?.products?.edges?.map((edge) => edge.node) || [];
    //   if (!products.length) return null;

    //   return products.filter((product) => {
    //     const minPrice = parseFloat(product?.priceRange?.minVariantPrice?.amount || 0);
    //     const maxPrice = parseFloat(product?.priceRange?.maxVariantPrice?.amount || 0);

    //     if (minPrice > filters.price.max || maxPrice < filters.price.min) return false;

    //     return product.variants.edges.some(({ node: variant }) => {
    //       const selectedOptions = variant.selectedOptions || [];

    //       // Return true if no option filters are applied
    //       if (!filters.option1.value && !filters.option2.value) return true;

    //       return (
    //         (!filters.option1.value || selectedOptions[0]?.value === filters.option1.value) &&
    //         (!filters.option2.value || selectedOptions[1]?.value === filters.option2.value)
    //       );
    //     });
    //   });
    // },

    getFilteredProducts(data, filters) {
      const products =
        data?.data?.products?.edges?.map((edge) => edge.node) || [];
      if (!products.length) return null;

      return products
        .map((product) => {
          const minPrice = parseFloat(
            product?.priceRange?.minVariantPrice?.amount || 0
          );
          const maxPrice = parseFloat(
            product?.priceRange?.maxVariantPrice?.amount || 0
          );

          // Filter out products outside the price range
          if (minPrice > filters.price.max || maxPrice < filters.price.min)
            return null;

          // Find the exact matching variant
          const matchingVariant = product.variants.edges.find(
            ({ node: variant }) => {
              const selectedOptions = variant.selectedOptions || [];

              // Get option values (assuming option1 is "Metal Color" and option2 is "Shape")
              const option1Value =
                selectedOptions.find((opt) => opt.name === filters.option1.name)
                  ?.value || "";
              const option2Value =
                selectedOptions.find((opt) => opt.name === filters.option2.name)
                  ?.value || "";

              // Exact match for both filters (if value is empty, it matches any)
              const matchesOption1 = filters.option1.value
                ? option1Value === filters.option1.value
                : true;
              const matchesOption2 = filters.option2.value
                ? option2Value === filters.option2.value
                : true;

              return matchesOption1 && matchesOption2;
            }
          )?.node;

          // If no matching variant is found, return null for this product
          if (!matchingVariant) return null;

          // Return the product with only the matching variant
          return {
            ...product,
            variants: {
              edges: [{ node: matchingVariant }],
            },
          };
        })
        .filter((product) => product !== null); // Remove products with no matching variants
    },

    async loadSettings(isLoadMore = false) {
      if (!isLoadMore) {
        this.page = 1;
        this.pageInfo = {
          endCursor: null,
          hasNextPage: false,
        };
      }

      this.loading = true;
      this.sendRequest = false;

      // Cancel any ongoing request
      if (this.request) this.cancelRequest();

      const axiosSource = axios.CancelToken.source();
      this.request = { cancel: axiosSource.cancel };

      const selectedMetal = this.getMetals.find(
        (item) =>
          item.slug ===
          (Array.isArray(this.filters?.initialFilters?.metals)
            ? this.filters?.initialFilters?.metals[0]
            : this.filters?.initialFilters?.metals)
      )?.label;
      const selectedShape = this.getShapes.find(
        (item) =>
          item.slug.toLowerCase() == this.filters?.initialFilters?.shapes
      )?.label;
      // Shared by the top-selling row and the main list, so both show the
      // variant for the metal / shape already applied (e.g. the shape of a
      // diamond chosen first) rather than each product's first variant.
      const priceFilter = {
        min: this.filters?.initialFilters?.price?.value?.[0] || "",
        max: this.filters?.initialFilters?.price?.value?.[1] || "",
      };
      const metalOption = {
        name: "Metal Color",
        value: selectedMetal?.replace(" Gold", "") || "",
      };
      const shapeOption = { name: "Shape", value: selectedShape || "" };
      try {
        if (this.filters.initialFilters.isTopSelling) {
          // Define filters for top-selling products
          const topFilters = {
            itemsPerPage: 12,
            price: priceFilter,
            option1: metalOption,
            option2: shapeOption,
            tag: ["top-selling-product"],
            sortItems: {
              sortBy: "BEST_SELLING",
              isDescending: true,
            },
          };

          // Fetch top-selling products
          const topResult = await this.fetchVariantOptions({
            apiVersion: "2026-04",
            accessToken: window.ShopifyConfig.storefrontAccessToken,
            collectionHandle: "engagement-rings",
            filters: topFilters,
            cursor: null,
            isNextPage: true,
          });
          if (topResult) {
            this.topSellingItems =
              topResult?.products
                ?.map((node) => ({
                  currency:
                    node.variants?.edges[0]?.node?.priceV2?.currencyCode,
                  id: node.variants?.edges[0]?.node?.id.split("/").reverse()[0],
                  handle: node.handle,
                  name: node.title,
                  tags: node.tags,
                  alternateImage:
                    node.variants?.edges[0]?.node?.image?.src || "",
                  image: node.variants?.edges[0]?.node?.image?.src || "",
                  sku: node.variants?.edges[0]?.node?.sku || "",
                  diamondShape:
                    node.variants?.edges[0]?.node?.selectedOptions.find(
                      (opt) => opt.name === "Shape"
                    )?.value || "",
                  metalType:
                    node.variants?.edges[0]?.node?.selectedOptions.find(
                      (opt) => opt.name === "Metal Color"
                    )?.value || "",
                  price:
                    node.variants?.edges[0]?.node?.priceV2?.amount || "0.00",
                  //   Pick metafield value (parse to integer for sorting)
                  salesCount: parseInt(
                    node.metafields?.find((m) => m.key === "sales_count")
                      ?.value || "0",
                    10
                  ),
                }))
                .sort((a, b) => b.salesCount - a.salesCount) || [];
          }
        }

        // Define the collection handle and filters
        const collectionHandle = "engagement-rings"; // Replace with your actual collection handle
        const filters = {
          itemsPerPage: 12, // Pagination limit
          price: priceFilter,
          option1: metalOption,
          option2: shapeOption,
          tag: this.filters?.initialFilters?.settingStyles || "", // Filter by tag (e.g., "Halo")
          sortItems: {
            sortBy: "PRICE",
            isDescending: this.filters?.initialFilters?.sortby != "price_asc",
          },
        };

        // Call the fetchVariantOptions function with the necessary parameters
        const result = await this.fetchVariantOptions({
          apiVersion: "2026-04", // Replace with your desired API version
          accessToken: window.ShopifyConfig.storefrontAccessToken, // Replace with your access token
          collectionHandle,
          filters,
          cursor: this.pageInfo.endCursor,
          isNextPage: this.pageInfo.hasNextPage,
        });

        if (!!result) {
          this.pageInfo = result.pageInfo;
        }

        // Process the fetched product data
        const products =
          result?.products?.map((node) => ({
            currency: node.variants?.edges[0]?.node?.priceV2?.currencyCode,
            id: node.variants?.edges[0]?.node?.id.split("/").reverse()[0],
            handle: node.handle,
            name: node.title,
            tags: node.tags,
            alternateImage: node.variants?.edges[0]?.node?.image?.src || "",
            image: node.variants?.edges[0]?.node?.image?.src || "",
            sku: node.variants?.edges[0]?.node?.sku || "",
            diamondShape:
              node.variants?.edges[0]?.node?.selectedOptions.find(
                (opt) => opt.name === "Shape"
              )?.value || "",
            metalType:
              node.variants?.edges[0]?.node?.selectedOptions.find(
                (opt) => opt.name === "Metal Color"
              )?.value || "",
            price: node.variants?.edges[0]?.node?.priceV2?.amount || "0.00",
          })) || [];

        if (products.length) {
          this.isMoreData = true;
          this.page += 1;

          if (isLoadMore) {
            this.items = [...this.items, ...products];
          } else {
            this.items = products;
          }

          this.dataNotFound = false;

          // Save current state to session
          this.saveCurrentPageToSession(this.page);
          this.saveSettingsToSession(this.items);
        } else {
          this.handleNoData();
        }

        // Update the product count
        this.diamondCount = isLoadMore
          ? Number(this.diamondCount) + Number(result?.products?.length)
          : result?.products?.length || 0;
        this.saveSettingCountToSession(this.diamondCount);

        this.sendRequest = true;
        this.loading = false;
      } catch (error) {
        this.loading = false;
        if (!axios.isCancel(error)) {
          this.handleNoData();
        }
        this.sendRequest = true;
      }
    },

    handleNoData() {
      this.isMoreData = false;
      this.dataNotFound = true;
      this.diamondCount = 0;
      this.page = 1;
      this.items = [];
    },

    sortItems(items) {
      items.sort((a, b) => {
        if (this.filters.initialFilters.sortby == "price_asc") {
          return a.price - b.price;
        } else {
          return b.price - a.price;
        }
      });
      return items;
    },
    loadSettingFilters() {
      if (sessionStorage.getItem("settings_filters") != null) {
        var savedFilters = JSON.parse(
          sessionStorage.getItem("settings_filters")
        );
        this.handleFilters(savedFilters);
      } else {
        var filters = {
          metal: [
            {
              slug: "platinum",
              label: "Platinum",
            },
            {
              slug: "9k-rose-gold",
              label: "9K Rose Gold",
            },
            {
              slug: "9k-white-gold",
              label: "9K White Gold",
            },
            {
              slug: "9k-yellow-gold",
              label: "9K Yellow Gold",
            },
            {
              slug: "14k-rose-gold",
              label: "14K Rose Gold",
            },
            {
              slug: "14k-white-gold",
              label: "14K White Gold",
            },
            {
              slug: "14k-yellow-gold",
              label: "14K Yellow Gold",
            },
            {
              slug: "18k-rose-gold",
              label: "18K Rose Gold",
            },
            {
              slug: "18k-white-gold",
              label: "18K White Gold",
            },
            {
              slug: "18k-yellow-gold",
              label: "18K Yellow Gold",
            },
          ],
          setting_style: [
            {
              slug: "nature-inspired",
              label: "Nature Inspired",
            },
            {
              slug: "solitaire",
              label: "Solitaire",
            },
            {
              slug: "halo",
              label: "Halo",
            },
            {
              slug: "bezel",
              label: "Bezel",
            },
            {
              slug: "pave",
              label: "Pave",
            },
            {
              slug: "three-stone",
              label: "Three Stone",
            },
            {
              slug: "hidden-halo",
              label: "Hidden Halo",
            },
            {
              slug: "vintage",
              label: "Vintage",
            },
            {
              slug: "side-stone",
              label: "Side Stone",
            },
            {
              slug: "toi-et-moi",
              label: "Toi et Moi",
            },
            {
              slug: "unique",
              label: "Unique",
            },
          ],
          shape: [
            {
              slug: "round",
              label: "Round",
            },
            {
              slug: "oval",
              label: "Oval",
            },
            {
              slug: "cushion",
              label: "Cushion",
            },
            {
              slug: "emerald",
              label: "Emerald",
            },
            {
              slug: "princess",
              label: "Princess",
            },
            {
              slug: "radiant",
              label: "Radiant",
            },
            {
              slug: "pear",
              label: "Pear",
            },
            {
              slug: "marquise",
              label: "Marquise",
            },
            {
              slug: "asscher",
              label: "Asscher",
            },
            {
              slug: "heart",
              label: "Heart",
            },
          ],
        };
        // filters.metal.sort(function (a, b) {
        //   if (a.label > b.label) return 1;
        //   if (a.label < b.label) return -1;
        //   return 0;
        // });
        const metalOrder = ["9k", "14k", "18k", "platinum"];
        const colorOrder = ["white", "yellow", "rose"];

        filters.metal.sort((a, b) => {
          const aKey = a.slug.startsWith("platinum")
            ? "platinum"
            : a.slug.split("-")[0];

          const bKey = b.slug.startsWith("platinum")
            ? "platinum"
            : b.slug.split("-")[0];

          const orderDiff = metalOrder.indexOf(aKey) - metalOrder.indexOf(bKey);

          // If same metal group, sort by color order
          if (orderDiff === 0) {
            const aColor = a.slug.includes("platinum")
              ? ""
              : a.slug.split("-")[1]; // white / yellow / rose

            const bColor = b.slug.includes("platinum")
              ? ""
              : b.slug.split("-")[1];

            return colorOrder.indexOf(aColor) - colorOrder.indexOf(bColor);
          }

          return orderDiff;
        });

        this.handleFilters(filters);
        sessionStorage.setItem("settings_filters", JSON.stringify(filters));
      }
    },
    changeRouterStyle() {
      const { settingStyles } = this.filters.initialFilters;

      const pathSegments = this.$route.path.split("/");
      const currentStyle = pathSegments[pathSegments.length - 1].toLowerCase();

      // If we're at base collection without specific style
      const isBasePath = currentStyle === "engagement-rings";

      let styleName = "";
      let finalStyles = [...settingStyles];

      // Check if path style exists in selected styles
      if (!isBasePath && settingStyles.includes(currentStyle)) {
        styleName = currentStyle;
      } else if (!isBasePath && settingStyles.length === 1) {
        styleName = settingStyles[0].toLowerCase();
      }

      // Always make sure the style in the path is included in internal filters
      if (styleName && !finalStyles.includes(styleName)) {
        finalStyles.push(styleName);
      }

      // Final styles for query (excluding the one already in the path)
      const queryStyles = finalStyles
        .filter((s) => s.toLowerCase() !== styleName)
        .map((s) => s.toLowerCase());

      const basePath = styleName
        ? `/engagement-rings/${styleName}`
        : `/engagement-rings`;

      const query =
        queryStyles.length > 0 ? { setting_styles: queryStyles.join("+") } : {};

      // Save back to filters (internal state)
      this.filters.initialFilters.settingStyles = finalStyles;
      // Update route
      this.$router.replace({
        path: basePath,
        query,
      });
    },
    handleFilters(filters) {
      if (Array.isArray(filters.metal) && filters.metal.length) {
        this.filters.metals.push(...filters.metal);
      }

      if (
        Array.isArray(filters.setting_style) &&
        filters.setting_style.length
      ) {
        this.filters.settingStyles.push(...filters.setting_style);
      }
      if (Array.isArray(filters.shape) && filters.shape.length) {
        this.filters.shapes.push(...filters.shape);
      }
    },
    setNewImage(targetElement, diamondShape) {
      targetElement.setAttribute("src", `${baseAssetsUrl}/diamond-ring.svg`);
    },
    handleUrlFilters() {
      if (Object.keys(this.$route.query).length) {
        var queryParams = this.$route.query;
        /* handle url setting styles parameters */

        this.applyUrlFilters(queryParams, "settingStyle", "settingStyles");
        /* handle url metal parameters */
        this.applyUrlFilters(queryParams, "settingMetal", "metals");
      }
    },
    applyUrlFilters(queryParams, urlKey, vueFilterVariable) {
      if (queryParams.hasOwnProperty(urlKey)) {
        const settingMetal = queryParams["settingMetal"];

        if (settingMetal) {
          this.filters.initialFilters.metals = [settingMetal];
          return;
        }
        const settingStyle = queryParams["settingStyle"];

        if (settingStyle) {
          if (!settingStyle || settingStyle == "settings") {
            this.filters.initialFilters.settingStyle = [];
          } else {
            this.filters.initialFilters.settingStyle = [settingStyle];
          }
          return;
        }

        var resultFilterOptions = queryParams[urlKey]
          .split(",")
          .filter((filterOption) => {
            return !this.filters.initialFilters[vueFilterVariable].includes(
              filterOption
            );
          });
        if (resultFilterOptions.length) {
          this.filters.initialFilters[vueFilterVariable].push(
            ...resultFilterOptions
          );
        }
      }
    },
    handleReactiveTooltip(isChecked) {
      isChecked
        ? this.handleTooltip("Diamond added for comapre", "")
        : this.handleTooltip(
          "Diamond removed from compare",
          "pc-tooltip-inactive"
        );
    },
    handleTooltip(tooltipMsg, tooltipClass) {
      if (this.timeOutId) clearTimeout(this.timeOutId);
      this.showTooltip = true;
      this.tooltipText = tooltipMsg;
      this.tooltipClass = tooltipClass;
      this.timeOutId = setTimeout(() => {
        this.showTooltip = false;
        this.tooltipText = "";
        this.tooltipClass = "";
      }, 1000);
    },
    /* Engagement Rings > <Style> Engagement Rings.
       Driven by settingStyles (the path style merged with ?setting_styles) rather than
       $route.params.setting: ticking a style from the base /engagement-rings path only
       writes the query — changeRouterStyle() leaves the path alone — so a param-only
       watcher never fired and the style crumb stayed missing. One style selected shows
       that style's crumb; none or several show just the listing crumb, matching the
       rule activeFaqStyle already uses. Rebuilds the whole array so the crumb clears
       when the style is unticked, and so index 0 is never left as a hole. */
    handleBreadcrumbs(styles) {
      const trail = [
        {
          path: "/collections/engagement-rings",
          name: "Engagement Rings",
        },
      ];
      const styleList = Array.isArray(styles)
        ? styles.filter(Boolean)
        : [styles].filter(Boolean);

      if (styleList.length === 1) {
        const settingName = String(styleList[0]).toLowerCase();
        const styleLabel =
          settingName == "settings"
            ? "All"
            : settingName
              .split("-")
              .join(" ")
              .split(" ")
              .filter(Boolean)
              .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
              .join(" ");
        trail.push({ path: "#", name: `${styleLabel} Engagement Rings` });
      }
      this.breadcrumbs = trail;
    },
    setWishlistItemsToStorage(settings) {
      if (settings.length) {
        localStorage.setItem("wishlistItems", JSON.stringify(settings));
      } else {
        localStorage.removeItem("wishlistItems");
      }
    },
    addToWishlist(settingName, settingId, e) {
      e.stopPropagation();
      const currentTargetEl = e.currentTarget;
      currentTargetEl.classList.add("pc-wishlist-loading");
      setTimeout(() => {
        currentTargetEl.classList.remove("pc-wishlist-loading");
        if (!this.filters.initialFilters.wishlistItems.includes(settingId)) {
          this.filters.initialFilters.wishlistItems.push(settingId);
          sessionStorage.setItem("status", "Great choice! This product has been added to your wishlist.");
        } else {
          sessionStorage.setItem("status", "Already exist in your wishlist");
        }
        sessionStorage.setItem("checkSettingId", settingId);
        this.setWishlistItemsToStorage(this.filters.initialFilters.wishlistItems);
        this.showWishlistPopup = true;
        this.wishlistItemName = settingName.name;
      }, 300);
    },
    searchDiamondByCert() {
      if (!this.filters.initialFilters.certificateNumber) {
        this.showCertError = true;
        return;
      } else {
        this.showCertError = false;
      }
      this.initializeAllFilters();
      this.applyFilters();
    },
    handleWidthOfSorters() {
      const totalWidth = 100;
      let totalSortCols = 0;
      for (sortField in this.filters.initialFilters.sortFields) {
        if (this.filters.initialFilters.sortFields[sortField].showField) {
          totalSortCols++;
        }
      }
      this.filters.initialFilters.sortColumnsWidth = `${(
        totalWidth / totalSortCols
      ).toFixed(2)}%`;
    },
    showAdvanceSortField(e, sortField, filterStateField) {
      if (Array.isArray(this.filters.initialFilters[filterStateField])) {
        if (this.filters.initialFilters[filterStateField].length < 1) {
          this.filters.initialFilters.sortFields[sortField].showField = false;
        } else {
          this.filters.initialFilters.sortFields[sortField].showField = true;
        }
      } else {
        this.filters.initialFilters.sortFields[sortField].showField = true;
      }
      this.handleWidthOfSorters();
    },
    changeListView(e) {
      this.filters.initialFilters.isListView =
        !this.filters.initialFilters.isListView;
      this.saveAppliedFilters();
    },
    toggleFilterDiv(e) {
      if (!this.toggleClass) {
        this.toggleClass = "pc-slide-down";
        this.bannerClass = "pc-hide-banner";
      } else if (this.toggleClass == "pc-slide-down") {
        this.toggleClass = "pc-slide-up";
        this.bannerClass = "pc-show-banner";
      } else {
        this.toggleClass = "pc-slide-down";
        this.bannerClass = "pc-hide-banner";
      }
    },
    removeInpValue(e) {
      e.currentTarget.value = "";
    },
    existFilter(filterType) {
      if (filterType == "shape") {
        // A diamond is already chosen, so its shape stays applied.
        this.filters.initialFilters.shapes =
          this.getSelectedDiamondShapeSlug() || [];
        this.applyFilters();
      }
      if (filterType == "metal") {
        this.filters.initialFilters.metals = "9k-white-gold";
        this.applyFilters();
      }
    },
    removeFilter(e, filterType, filterValue = "") {
      if (this.$options.sliderOptions.includes(filterType)) {
        this.filters.initialFilters[filterType].value = [
          this.filters[filterType].min,
          this.filters[filterType].max,
        ];
      } else if (filterType == "certificateNumber") {
        this.filters.initialFilters[filterType] = "";
      } else if (filterType == "settingStyles") {
        this.filters.initialFilters[filterType] = [];
        this.changeRouterStyle();
      } else {
        if (filterType.includes("shape")) {
          this.filters.initialFilters[filterType] = "";
        } else {
          if (filterValue.length) {
            this.filters.initialFilters[filterType] =
              this.filters.initialFilters[filterType].filter(
                (initFilterValue) => {
                  return (
                    initFilterValue.toLowerCase() != filterValue.toLowerCase()
                  );
                }
              );
          } else {
            this.filters.initialFilters[filterType] = [];
          }
        }
      }
      this.applyFilters();
    },

    setSliderValues(e, sliderType, valueType) {
      var inputValue = !e.currentTarget.value
        ? this.filters.initialFilters[sliderType].value[
        valueType == "min" ? 0 : 1
        ]
        : e.currentTarget.value.replace(/[^0-9\.\-\+]/g, "");
      inputValue =
        sliderType === "price"
          ? Math.round(parseInt(inputValue))
          : parseFloat(inputValue);
      if (valueType == "min") {
        if (
          inputValue < this.filters[sliderType].min ||
          inputValue > this.filters[sliderType].max
        ) {
          inputValue = this.filters[sliderType].min;
        }
        if (inputValue == this.filters.initialFilters[sliderType].value[0]) {
          e.currentTarget.value =
            sliderType !== "price"
              ? this.filters.initialFilters[sliderType].value[0] +
              " " +
              this.filters[sliderType].symbol
              : this.filters[sliderType].symbol +
              " " +
              this.filters.initialFilters[sliderType].value[0].toLocaleString(
                "en-US"
              );
          return;
        }
        this.filters.initialFilters[sliderType].value[0] = inputValue;
      } else if (valueType == "max") {
        if (
          inputValue > this.filters[sliderType].max ||
          inputValue < this.filters[sliderType].min
        ) {
          inputValue = this.filters[sliderType].max;
        }
        if (inputValue == this.filters.initialFilters[sliderType].value[1]) {
          e.currentTarget.value =
            sliderType !== "price"
              ? this.filters.initialFilters[sliderType].value[1] +
              " " +
              this.filters[sliderType].symbol
              : this.filters[sliderType].symbol +
              " " +
              this.filters.initialFilters[sliderType].value[1].toLocaleString(
                "en-US"
              );
          return;
        }
        this.filters.initialFilters[sliderType].value[1] = inputValue;
      }
      this.applyFilters();
    },
    // Reset keeps the shape of the diamond already in the build (any diamond
    // type — this used to read only the natural list's filters).
    getSelectedDiamondShape() {
      const shape = this.getSelectedDiamondShapeSlug();
      this.selectedDiamondShapes = shape ? [shape] : [];
      this.filters.initialFilters.shapes = shape || [];
    },
    initializeAllFilters(isResetRequest = 0) {
      var mainFiltersJson = this.filters;
      var initialFiltersJson = mainFiltersJson.initialFilters;
      this.currentFilterTab = "View All";
      for (initialFilter in initialFiltersJson) {
        if (initialFilter == "isListView") continue;
        if (Array.isArray(initialFiltersJson[initialFilter])) {
          // if (initialFilter == "metals") {
          //   initialFiltersJson[initialFilter] = "9k-white-gold";
          // }
          if (initialFilter == "settingStyles") {
            initialFiltersJson[initialFilter] = [];
            this.changeRouterStyle(initialFiltersJson[initialFilter]);
          } else if (initialFilter == "shapes") {
            this.getSelectedDiamondShape();
          } else {
            initialFiltersJson[initialFilter] = [];
          }
        } else if (typeof initialFiltersJson[initialFilter] == "string") {
          if (initialFilter == "metals") {
            initialFiltersJson[initialFilter] = "9k-white-gold";
          } else if (initialFilter == "shapes") {
            this.getSelectedDiamondShape();
          } else if (initialFilter == "sortby") {
            initialFiltersJson[initialFilter] = "price_asc";
          } else {
            initialFiltersJson[initialFilter] = "";
          }
        } else if (initialFilter == "sortby") {
          initialFiltersJson[initialFilter] = "price_asc";
        } else if (this.$options.sliderOptions.includes(initialFilter)) {
          initialFiltersJson[initialFilter] = {
            value: [
              mainFiltersJson[initialFilter].min,
              mainFiltersJson[initialFilter].max,
            ],
          };
        }
      }
      this.showCertError = false;
    },
    resetFilters() {
      this.initializeAllFilters(1);
      this.applyFilters("", undefined, true);
    },
    resetMobileFilters(e, keys = undefined) {
      e.preventDefault();
      e.stopPropagation();

      if (!!keys && this.currentFilterTab != "View All") {
        var filtername;
        if (this.currentFilterTab.toLowerCase().includes("setting style")) {
          filtername = "settingStyles";
        } else if (
          this.currentFilterTab.toLowerCase().includes("metal") ||
          this.currentFilterTab.toLowerCase().includes("shape")
        ) {
          filtername = `${this.currentFilterTab.toLowerCase()}s`;
        } else if (this.currentFilterTab.toLowerCase().includes("price")) {
          filtername = "price";
        }
        this.removeFilter(e, filtername, "");
      } else {
        this.resetFilters();
      }
    },
    injectAppliedFilters() {
      var appliedFilters = sessionStorage.getItem(
        "chooseSettingsAppliedFilters"
      );
      if (appliedFilters != null) {
        let filtersObj = JSON.parse(appliedFilters);
        if (filtersObj.metals.length == 0) {
          filtersObj.metals.push("9k-white-gold");
        }
        this.filters.initialFilters = filtersObj;
      }
      const { setting } = this.$route.params;
      const { setting_styles } = this.$route.query;

      let stylesFromParam = [];
      let stylesFromQuery = [];

      // Handle param: if it's not 'settings', include it
      if (setting && setting.toLowerCase() !== "settings") {
        stylesFromParam = [setting.toLowerCase()];
      }

      // Handle query: decode, split, filter
      if (setting_styles) {
        stylesFromQuery = decodeURIComponent(setting_styles.toLowerCase())
          .split("+")
          .filter(Boolean);
      }

      // Merge both, remove duplicates
      const mergedStyles = [
        ...new Set([...stylesFromParam, ...stylesFromQuery]),
      ];

      // Set to initialFilters
      if (mergedStyles.length) {
        this.filters.initialFilters.settingStyles = mergedStyles;
      } else {
        this.filters.initialFilters.settingStyles = [];
        this.changeRouterStyle();
        sessionStorage.setItem(
          "chooseSettingsAppliedFilters",
          JSON.stringify(this.filters.initialFilters)
        );
      }

      if (localStorage.getItem("wishlistItems") != null) {
        this.filters.initialFilters.wishlistItems = JSON.parse(
          localStorage.getItem("wishlistItems")
        );
      }
      // this.injectWishlistSettingsFromCookie()
    },
    injectWishlistSettingsFromCookie() {
      if (wishlistSettingIds.length) {
        var nonExistWishlistSettingIds = wishlistSettingIds.filter(
          (wishlistSettingId) => {
            if (
              !this.filters.initialFilters.wishlistItems.includes(
                wishlistSettingId
              )
            ) {
              return wishlistSettingId;
            }
          }
        );
        this.filters.initialFilters.wishlistItems.push(
          ...nonExistWishlistSettingIds
        );
      }
    },
    saveAppliedFilters() {
      sessionStorage.setItem(
        "chooseSettingsAppliedFilters",
        JSON.stringify(this.filters.initialFilters)
      );
    },
    applyFilters(style, type = undefined, isReset = false) {
      if (type == "settingStyle") {
        this.changeRouterStyle(style);
      }

      if (isReset) {
        this.filters.initialFilters.isTopSelling = true;
      } else {
        this.filters.initialFilters.isTopSelling = false;
      }
      // this.handleMetalFilterOptions();
      // this.handleShapeFilterOptions()
      this.shouldShowAppliedFilters();
      this.page = 1;
      this.items = [];
      this.topSellingItems = [];

      this.saveAppliedFilters();
      /* remove settinglist and current page, setting count from cached session before load new settings from ajax */
      this.removeSettingMetaData();
      this.loadSettings();
    },
    // handleMetalFilterOptions() {
    //   if (this.filters.initialFilters.metals.length > 1) {
    //     this.filters.initialFilters.metals.shift();
    //   }
    // },
    handleShapeFilterOptions() {
      if (!!this.filters.initialFilters.shapes.length) {
        if (Array.isArray(this.filters.initialFilters.shapes)) {
          this.filters.initialFilters.shapes.shift();
        } else {
          this.filters.initialFilters.shapes.split(",").shift();
        }
      }
    },
    shouldShowAppliedFilters() {
      for (let filter of this.$options.regularFilters) {
        if (Array.isArray(this.filters.initialFilters[filter])) {
          if (this.filters.initialFilters[filter].length) {
            this.filters.initialFilters.showAppliedFiltersSection = true;
            return;
          } else {
            this.filters.initialFilters.showAppliedFiltersSection = false;
          }
        } else if (this.$options.sliderOptions.includes(filter)) {
          if (
            this.filters.initialFilters[filter].value[0] !=
            this.filters[filter].min ||
            this.filters.initialFilters[filter].value[1] !=
            this.filters[filter].max
          ) {
            this.filters.initialFilters.showAppliedFiltersSection = true;
            return;
          } else {
            this.filters.initialFilters.showAppliedFiltersSection = false;
          }
        } else if (typeof this.filters.initialFilters[filter] == "string") {
          if (this.filters.initialFilters[filter] != "") {
            this.filters.initialFilters.showAppliedFiltersSection = true;
            return;
          } else {
            this.filters.initialFilters.showAppliedFiltersSection = false;
          }
        }
      }
    },
    clearOldRequest() {
      this.request = null;
    },
    cancelRequest() {
      this.request.cancel();
      this.request = null;
    },
    applySort(val) {
      this.filters.initialFilters.sortby = val;
      this.isDDOpen = false;
      this.applyFilters();
    },
    getPageUrl() {
      return document.URL;
    },
    getMetaData(type) {
      switch (type) {
        case "description":
          return "Choose your favourite setting for build a complete ring";
        case "title":
          return "Choose Settings";
        case "siteName":
          return "Vue Woocomerce";
        case "type":
          return "website";
      }
    },
    handleMetaData() {
      // document.title = this.$t(this.getMetaData("title"));
      /* set default and openGraph meta data for filter page */
      const meta = [
        { name: "description", content: this.getMetaData("description") },
        { property: "og:title", content: this.getMetaData("title") },
        { property: "og:site_name", content: this.getMetaData("siteName") },
        { property: "og:type", content: this.getMetaData("type") },
        { property: "og:url", content: this.getPageUrl() },
        {
          property: "og:description",
          content: this.getMetaData("description"),
        },
      ];
      const link = [{ rel: "canonical", href: this.getPageUrl() }];
      // setMetaData("meta", meta);
      // setMetaData("link", link);
    },
  },
  watch: {
    diamondCount: {
      deep: true,
      handler(value) {
        // Set the initial visibility of the button
        if (
          this.pageInfo?.hasNextPage &&
          this.diamondCount <= 12 &&
          this.diamondCount > 0
        ) {
          this.isLoadMoreBtnActive = true;
        } else {
          this.isLoadMoreBtnActive = false;
        }
      },
    },
    pageInfo: {
      deep: true,
      handler(value) {
        sessionStorage.setItem("settingListPageInfo", JSON.stringify(value));
      },
    },
    // Watch for changes to the route's query parameter
    "$route.query.setting_styles": {
      immediate: true, // Run immediately when component is created
      handler(newStyles) {
        if (newStyles) {
          // Decode and split styles (e.g., 'hidden-halo+vintage' -> ['hidden-halo', 'vintage'])
          const decodedStyles = decodeURIComponent(newStyles).split("+");
          // Update filters with extracted styles
          this.filters.initialFilters.settingStyles = decodedStyles;
        } else {
          // Clear styles if no setting_styles query param
          this.filters.initialFilters.settingStyles = [];
        }
      },
    },
    "filters.initialFilters.settingStyles": {
      immediate: true, // Run immediately when component is created
      handler(newStyles) {
        // Styles land here from both entry points (path segment and query), so this is
        // what keeps the breadcrumb in step with the filter UI.
        this.handleBreadcrumbs(newStyles);
        if (newStyles && newStyles?.length) {
          this.filters.initialFilters.isTopSelling = false;
        } else {
          this.filters.initialFilters.isTopSelling = true;
        }
      },
    },
    "filters.initialFilters.isTopSelling": {
      immediate: true, // Run immediately when component is created
      handler(newStyles) {
        if (!newStyles) {
          this.topSellingItems = [];
        }
      },
    },
    items: {
      immediate: true, // Run immediately when component is created
      handler(newStyles) {
        if (!this.filters.initialFilters.isTopSelling) {
          this.topSellingItems = [];
        }
      },
    },
    "$route.params.setting": {
      immediate: true,
      handler(newValue, oldValue) {
        // Direct entry to /engagement-rings/<style>, before injectAppliedFilters has
        // merged it into settingStyles. Filter clicks go through that watcher instead.
        if (!!newValue) {
          this.handleBreadcrumbs(newValue);
        }
      },
    },
  },
  beforeRouteEnter(to, from) {
    if (sessionStorage.getItem("firstPage")) {
      var firstPage = sessionStorage.getItem("firstPage");
      if (firstPage == "diamondPage") {
        resetRingFromSession("notSelected");
      }
    }
    if (sessionStorage.getItem("selectedDiamond") === null) {
      sessionStorage.setItem("firstPage", "settingPage");
    }
    // sessionStorage.setItem("firstPage", "settingPage")
  },
  beforeRouteLeave(to, from) {
    window.removeEventListener("scroll", this.handleScroll);
  },
  beforeMount() {
    document.getElementById("initial-page-loader").style.display = "none";
    let elements = document.getElementsByClassName("js-recently-view");
    for (let i = 0; i < elements.length; i++) {
      elements[i].style.display = "block";
    }
  },
};
